import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireSession } from '~/lib/route-auth';

export const Route = createFileRoute('/rooms')({
  beforeLoad: async () => {
    await requireSession();
  },
  component: RoomsLayout
});

function RoomsLayout() {
  return <Outlet />;
}
